import { Injectable } from "@angular/core";
import { CertificationItem as CertificationItemDto } from "src/app/proxy/certifications/models";
import { CertificationItem } from "../../entities/certification-item";
import { LocalDbService } from "../local-db-service";

@Injectable({ providedIn: 'root' })
export class CertificationItemRepository {
  private get table() {
    return this.db.certificationItemsTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getAll(): Promise<CertificationItem[]> {
    return await this.table.toArray();
  }

  async getAllByActivityReportId(activityReportId: string): Promise<CertificationItem[]> {
    return await this.table.where('activityReportId').equals(activityReportId).toArray();
  }

  async create(item: CertificationItem | CertificationItemDto): Promise<string> {
    const row = new CertificationItem(item);
    await this.table.add(row);
    return row.localId;
  }

  async upsertBulk(items: Array<CertificationItem | CertificationItemDto>): Promise<void> {
    if (items.length === 0) {
      return;
    }

    const rows = items.map(item => new CertificationItem(item));
    await this.table.bulkPut(rows);
  }

  async delete(id: number): Promise<void> {
    await this.table.where('id').equals(id).delete();
  }

  async deleteAllByActivityReportId(activityReportId: string): Promise<number> {
    return this.table.where('activityReportId').equals(activityReportId).delete();
  }

  async clear(): Promise<void> {
    await this.table.clear();
  }
}
